import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  SET_AUTHENTICATED_2FA,
  CAPTCHA_RESET,
  CLEAR_CAPTCHA_RESET,
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: localStorage.getItem('cobcloud_user'),
  authUserInfo: null,
  authenticated_2f2: null,
  resetCaptcha: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_AUTHENTICATED_2FA: {
      return {
        ...state,
        loader: false,
        authenticated_2f2: action.payload,
      };
    }
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload.id_uuid,
        authUserInfo: action.payload,
      };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        authUserInfo: null,
        initURL: '/app/cob',
        loader: false,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    case CAPTCHA_RESET:
      return {
        ...state,
        resetCaptcha: true,
      };
    case CLEAR_CAPTCHA_RESET:
      return {
        ...state,
        resetCaptcha: false,
      };
    default:
      return state;
  }
};
